import { render, staticRenderFns } from "./AccettazioneSsnAccettazioneNreModal.vue?vue&type=template&id=38d3c4ba&scoped=true"
import script from "./AccettazioneSsnAccettazioneNreModal.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAccettazioneNreModal.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnAccettazioneNreModal.vue?vue&type=style&index=0&id=38d3c4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3c4ba",
  null
  
)

export default component.exports